webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(24),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Polidog__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Polidog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Polidog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Buttons__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Messages__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StartButton__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StartButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StartButton__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Polidog: __WEBPACK_IMPORTED_MODULE_1__components_Polidog___default.a,
    Buttons: __WEBPACK_IMPORTED_MODULE_2__components_Buttons___default.a,
    Messages: __WEBPACK_IMPORTED_MODULE_3__components_Messages___default.a,
    StartButton: __WEBPACK_IMPORTED_MODULE_4__components_StartButton___default.a
  },
  data: function data() {
    return {
      isStarted: false,
      time: {
        start: undefined,
        record: undefined,
        measuring: undefined
      },
      count: 0,
      correctAnswerCount: 0,
      flagState: {
        left: -1,
        right: -1
      },
      answer: {
        left: -1,
        right: -1
      },
      question: undefined,
      colorText: { red: 'あか', white: 'しろ' },
      movementText: {
        raise: ['あげて！', 'さげないで！'],
        lower: ['さげて！', 'あげないで！']
      },
      message: {
        isCorrect: undefined,
        correctAnswerCount: undefined
      }
    };
  },

  methods: {
    initialize: function initialize() {
      this.isStarted = false;
      this.count = 0;
      this.correctAnswerCount = 0;
      this.flagState.right = -1;
      this.flagState.left = -1;
      this.answer.right = -1;
      this.answer.left = -1;
    },
    random: function random(array) {
      var random = array[Math.floor(Math.random() * array.length)];
      return random;
    },
    startGame: function startGame() {
      this.isStarted = true;
      this.updateQuestion();
    },
    endGame: function endGame() {
      if (this.count >= 10) {
        var correctAnswerCountToDisplay = this.correctAnswerCount;
        this.message.correctAnswerCount = '10問中' + correctAnswerCountToDisplay + '問正解でした！';
        this.initialize();
      }
    },
    updateData: function updateData(hand) {
      this.incrementCount();
      this.setFlagState(hand);
      this.checkAnswer();
      if (this.count < 10) {
        this.updateQuestion();
      }
    },
    incrementCount: function incrementCount() {
      this.count += 1;
    },
    setFlagState: function setFlagState(hand) {
      switch (hand) {
        case 'left':
          this.flagState.left *= -1;
          break;
        case 'right':
          this.flagState.right *= -1;
          break;
        case 'center':
          break;
      }
    },
    checkAnswer: function checkAnswer() {
      var answerJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.answer);
      var flagStateJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.flagState);
      if (answerJson === flagStateJson) {
        this.message.isCorrect = '正解！(｀・ω・´)';
        this.correctAnswerCount += 1;
      } else {
        this.message.isCorrect = '不正解...(´・ω・｀)';
      }
    },
    updateQuestion: function updateQuestion() {
      var flagColor = this.createAnswer();
      this.question = this.createQuestion(flagColor);
    },
    createAnswer: function createAnswer() {
      var random = this.random([0, 1, 2]);
      switch (random) {
        case 0:
          this.answer.left = this.flagState.left * -1;
          this.answer.right = this.flagState.right;
          return 1;
        case 1:
          this.answer.left = this.flagState.left;
          this.answer.right = this.flagState.right * -1;
          return 0;
        case 2:
          this.answer.left = this.flagState.left;
          this.answer.right = this.flagState.right;
          var array2 = [0, 1];
          var random2 = array2[Math.floor(Math.random() * array2.length)];
          return random2;
      }
    },
    createQuestion: function createQuestion(flagColor) {
      var answerType = this.classifyAnswer();
      var createQuestionText = this.createQuestionText(answerType, flagColor);
      return createQuestionText;
    },
    classifyAnswer: function classifyAnswer() {
      var answerType = void 0;
      if (this.answer.left === 1) {
        answerType = this.answer.right === 1 ? 0 : 1;
      } else {
        answerType = this.answer.right === 1 ? 2 : 3;
      }
      return answerType;
    },
    createQuestionText: function createQuestionText(answerType, flagColor) {
      var questionText = flagColor === 0 ? this.colorText.red : this.colorText.white;
      var feint = this.random([0, 1]);
      switch (answerType) {
        case 0:
          questionText += this.movementText.raise[feint];
          break;
        case 1:
          questionText += flagColor === 0 ? this.movementText.lower[feint] : this.movementText.raise[feint];
          break;
        case 2:
          questionText += flagColor === 0 ? this.movementText.raise[feint] : this.movementText.lower[feint];
          break;
        case 3:
          questionText += this.movementText.lower[feint];
          break;
      }
      return questionText;
    },
    stopWatch: function stopWatch() {
      if (this.isStarted) {
        this.time.start = new Date();
        this.time.measuring = setInterval(this.displayTime, 1);
      }
      if (!this.isStarted) {
        this.displayTime();
        clearInterval(this.time.measuring);
      }
    },
    displayTime: function displayTime() {
      var stop = new Date();
      var allTime = stop.getTime() - this.time.start.getTime();
      var hour = Math.floor(allTime / (60 * 60 * 1000));
      allTime = allTime - hour * 60 * 60 * 1000;
      var minute = Math.floor(allTime / (60 * 1000));
      allTime = allTime - minute * 60 * 1000;
      var second = Math.floor(allTime / 1000);
      var msecond = allTime % 1000;
      this.time.record = hour + '時間' + minute + '分' + second + '秒' + msecond;
    }
  },
  watch: {
    count: 'endGame',
    isStarted: 'stopWatch'
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'buttons',
  props: {
    flagState: Object,
    isStarted: Boolean,
    count: Number
  },
  methods: {
    moveFlag: function moveFlag(hand) {
      this.$emit('updateData', hand);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'messages',
  props: {
    question: String,
    message: Object,
    time: Object
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'polidog',
  props: {
    flagState: Object
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'start-button',
  props: {
    isStarted: Boolean
  },
  methods: {
    startGame: function startGame() {
      this.$emit('startGame');
    }
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polidog_flag_left.f9011b2.png";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polidog_flag_raise_left.6c42c66.png";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polidog_flag_raise_right.3f092f6.png";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/polidog_flag_right.aec1f5e.png";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(28),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(27),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(25),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('polidog', {
    attrs: {
      "flagState": _vm.flagState
    }
  }), _vm._v(" "), _c('buttons', {
    attrs: {
      "flagState": _vm.flagState,
      "isStarted": _vm.isStarted,
      "count": _vm.count
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('messages', {
    attrs: {
      "time": _vm.time,
      "question": _vm.question,
      "message": _vm.message
    }
  }), _vm._v(" "), _c('start-button', {
    attrs: {
      "isStarted": _vm.isStarted
    },
    on: {
      "startGame": _vm.startGame
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "startbutton"
  }, [_c('button', {
    staticClass: "start",
    attrs: {
      "disabled": _vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.startGame()
      }
    }
  }, [_vm._v("\n    START！\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.question))]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message.isCorrect))]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message.correctAnswerCount))]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.time.record))])])
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "polidog"
  }, [_c('div', {
    staticClass: "right"
  }, [(_vm.flagState.right === 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(18)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(19)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [(_vm.flagState.left === 1) ? _c('img', {
    attrs: {
      "src": __webpack_require__(17)
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(16)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('button', {
    staticClass: "right",
    attrs: {
      "disabled": !_vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.moveFlag('right')
      }
    }
  }, [(_vm.flagState.right === -1) ? _c('span', [_vm._v("↑")]) : _c('span', [_vm._v("↓")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('button', {
    staticClass: "center",
    attrs: {
      "disabled": !_vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.moveFlag('center')
      }
    }
  }, [_c('span', [_vm._v("Keep")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('button', {
    staticClass: "left",
    attrs: {
      "disabled": !_vm.isStarted
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.moveFlag('left')
      }
    }
  }, [(_vm.flagState.left === -1) ? _c('span', [_vm._v("↑")]) : _c('span', [_vm._v("↓")])])])])])
},staticRenderFns: []}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.5d7db264accf681c9067.js